import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { AuthProvider } from "./utils/Auth/AuthContext";
import router from "./router/router";
const App = ({ store }) => (
  <Provider store={store}>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </Provider>
);

export default App;
